import React from 'react';

import Navbar from '../Navbar';

function NavbarLocal(props) {
  return (
    <div className="navbar-local">
      <Navbar localMenu={true} {...props} />
    </div>
  );
}

export default NavbarLocal;
